import { includesValue } from '@/helpers/object.js'
import { THEMES, VARIANTS } from '@/components/_shared/Form/form-helper'

export const TYPES = {
  text: 'text',
  email: 'email',
  password: 'password',
  tel: 'tel',
}

export const INPUT_TAGS = {
  input: 'input',
  textarea: 'textarea',
}

export const LABEL_VARIANTS = {
  animated: 'animated',
  fixed: 'fixed',
}

export const LABEL_STYLES = {
  normal: 'normal',
  bold: 'bold',
}

export default {
  value: {
    required: true,
  },
  type: {
    type: String,
    default: TYPES.text,
    validator(value) {
      return includesValue(TYPES, value)
    },
  },
  inputTag: {
    type: String,
    default: INPUT_TAGS.input,
    validator(value) {
      return includesValue(INPUT_TAGS, value)
    },
  },
  id: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  labelVariant: {
    type: String,
    default: LABEL_VARIANTS.animated,
    validator(value) {
      return includesValue(LABEL_VARIANTS, value)
    },
  },
  labelStyle: {
    type: String,
    default: LABEL_STYLES.normal,
    validator(value) {
      return includesValue(LABEL_STYLES, value)
    },
  },
  placeholder: {
    type: String,
    default: '',
  },
  isRequired: {
    type: Boolean,
    default: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  autocomplete: {
    type: String,
  },
  theme: {
    type: String,
    default: THEMES.default,
    validator(value) {
      return includesValue(THEMES, value)
    },
  },
  variant: {
    type: String,
    default: VARIANTS.default,
    validator(value) {
      return includesValue(VARIANTS, value)
    },
  },
  isCharacterCountActive: {
    type: Boolean,
    default: false,
  },
  maxCharacters: {
    type: Number,
    default: 0,
  },
  showIndicator: {
    type: Boolean,
    default: true,
  },
}
